import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomPipesModule } from "@app/_pipes/custom-pipes.module";
import { MaterialModule } from "@app/material.module";
import { TagPickerDialogModule } from "@app/shared/dialogs/tag-picker-dialog/tag-picker-dialog.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { DateFnsModule } from "ngx-date-fns";
import { TimeEntryComponent } from "./time-entry.component";

@NgModule({
	declarations: [TimeEntryComponent],
	imports: [
		CommonModule,
		MaterialModule,

		TranslateModule,
		CustomPipesModule,
		FormsModule,
		ReactiveFormsModule,
		DateFnsModule,
		TagPickerDialogModule,
		UserAvatarModule,
	],
	exports: [TimeEntryComponent],
})
export class TimeEntryModule {}
